import {WithoutSummaryModel} from '../../../../../common/entity/dto/plain/withoutSummary.model';
import {DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';

export class Scan3dModel extends WithoutSummaryModel {
    document: DocumentSummaryModel;
    side: string;
}

export enum Scan3dReferencial {
    SCAN= 'INSOLE_SCAN_REFENCIAL_TYPE_SCAN',
    PELLET = 'INSOLE_SCAN_REFENCIAL_TYPE_PELLET',
    SCANNER = 'INSOLE_SCAN_REFENCIAL_TYPE_SCANNER'
}
